<div class="toast-wrapper" [ngClass]="'toast--' + notificationType">
  <!-- Icon -->
  <div class="toast-icon">
    <mat-icon>{{ iconName }}</mat-icon>
  </div>

  <!-- Content -->
  <div class="toast-content">
    @if (toastTitle) {
      <div class="toast-title">{{ toastTitle }}</div>
    }
    <div class="toast-message">{{ toastMessage }}</div>
  </div>

  <!-- Action button (optional) -->
  @if (actionLabel) {
    <button
      mat-button
      class="toast-action"
      (click)="onAction($event)"
    >
      {{ actionLabel }}
    </button>
  }

  <!-- Close button (optional) -->
  @if (showCloseButton) {
    <button
      mat-icon-button
      class="toast-close"
      (click)="remove()"
      [attr.aria-label]="'COMMON.CLOSE' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
